import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Products = lazy(() => import('../pages/products/page'));
const MoringaPowderProduct = lazy(() => import('../pages/products/moringa-powder/page'));
const Partnerships = lazy(() => import('../pages/partnerships/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Privacy = lazy(() => import('../pages/privacy/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/about', element: <About /> },
  { path: '/products', element: <Products /> },
  { path: '/products/moringa-powder', element: <MoringaPowderProduct /> },
  { path: '/partnerships', element: <Partnerships /> },
  { path: '/blog', element: <Blog /> },
  { path: '/contact', element: <Contact /> },
  { path: '/privacy', element: <Privacy /> },
  { path: '/terms', element: <Terms /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
